import clinical from "./clinical";
import wellness from "./wellness";

export const TERM_SETS = { clinical, wellness };

/** Terim seti anahtarından sözlük (bilinmeyen → klinik). */
export const termsFor = (termSet) => TERM_SETS[termSet] || clinical;

export { clinical, wellness };
